// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tropius: PokeData = {
  "id": 357,
  "name": "tropius",
  "height": 20,
  "weight": 1000,
  "base_experience": 161,
  "types": [
    PokeType.GRASS,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "stomp",
    "body-slam",
    "leer",
    "growth",
    "razor-leaf",
    "solar-beam",
    "outrage",
    "sweet-scent",
    "synthesis",
    "magical-leaf",
    "dragon-dance",
    "natural-gift",
    "air-slash",
    "leaf-storm",
    "wide-guard",
    "bestow",
    "leaf-tornado",
    "dragon-hammer"
  ],
  "moves": [
    "gust",
    "body-slam",
    "leer",
    "razor-leaf",
    "solar-beam",
    "outrage",
    "synthesis",
    "dragon-dance",
    "air-slash",
    "leaf-tornado",
    "power-whip",
    "aerial-ace",
    "chatter"
  ],
  "evolution_chain": {
    "id": 183,
    "item": null,
    "species": [
      {
        "name": "tropius",
        "order": 386,
        "types": [
          PokeType.GRASS,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 171,
    "speed": 95,
    "ability_power": 134
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
